import React from "react";
import { FormGroup, Input } from "reactstrap";
import cx from "classnames";

import Icon from "../../Icon/Icon";
import s from "./TableSearch.module.scss";

export default function TableSearch({
	searchText,
	setSearchText = () => {},
	className = "",
}) {
	const clearSearch = () => {
		setSearchText("");
	};

	return (
		<FormGroup className={cx(s.root, className)}>
			<Input
				className={cx(s.searchInput, { [s.placeholder]: !searchText })}
				placeholder={"Search"}
				value={searchText || ""}
				onChange={(e) => setSearchText(e.target.value)}
			/>

			{searchText ? (
				<div className={s.iconContainer}>
					<Icon icon="clear" onClick={clearSearch} className={s.pointer} />
				</div>
			) : (
				<div className={s.iconContainer}>
					<Icon icon="search" />
				</div>
			)}
		</FormGroup>
	);
}
